import type { TutorialStep } from './types';

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    targetSelector: '[data-tutorial="new-chat-btn"]',
    title: 'Start a new conversation',
    description: 'Click here to clear the screen and open a blank chat thread at any time.',
    popoverPosition: 'right',
    requiresSidebar: true,
  },
  {
    targetSelector: '[data-tutorial="chat-history"]',
    title: 'Your previous conversations',
    description:
      'All your past queries are saved here, organized by date, so you can return to them whenever you want.',
    popoverPosition: 'right',
    requiresSidebar: true,
  },
  {
    targetSelector: '[data-tutorial="message-input"]',
    title: 'Ask your questions',
    description: 'Type any technical question or query about Phytobiotics products here.',
    popoverPosition: 'top',
    requiresSidebar: false,
  },
  {
    targetSelector: '[data-tutorial="category-buttons"]',
    title: 'Not sure where to begin?',
    description:
      'Tap one of these to browse ready-made queries — filtered by topic (research, analysis, sales tools) or the latest available studies.',
    popoverPosition: 'top',
    requiresSidebar: false,
  },
];
